import React, { Component } from 'react'
import Header from './Header'
import Player from './Player'
import Footer from './Footer'
import Survey from './Survey'
import '../styles/lax.css'
import { config } from '../config'
import Activity from './Activity'
import Login from './Login'
import Ending from './Ending'

import { CSSTransitionGroup } from 'react-transition-group' // ES6

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      user: [],
      fin: false,
      ix: 0,
      recs: '',
      surv: false,
      vid: false,
      activity: false,
      captionsOn: false
    }

    this.userHasAuthenticated = this.userHasAuthenticated.bind(this);
  }

  userHasAuthenticated = (authenticated, user) => {
    this.setState({
      isAuthenticated: authenticated,
      user: user,
      vid: authenticated,
      recs: user.quizData
    })
  }

  ix = i => {
    this.setState({
      ix: i,
      vid: true,
      surv: false,
      fin: false,
      activity: false,
      captionsOn: this.state.captionsOn
    })
  }

  checkSurveyCompletion = (module) => {
    return this.state.recs[module]
  }

  isCompleted = (object) => {
    return Object.keys(object).find(key => object[key] === 0);
  }

  onVidEnd = () => {
    const module = config.playlist[this.state.ix]
    const record = this.checkSurveyCompletion(config.playlist[this.state.ix].survey)
    if (module.activity && this.state.vid) {
      this.setState({vid: false, surv: false, activity: true, captionsOn: this.state.captionsOn})
    } else if (module.survey && !record) {
      this.setState({vid: false, surv: true, activity: false, captionsOn: this.state.captionsOn})
    } else {
      this.setCompl()
    }
  }

  onTextChange = () => {
    this.setState({
      captionsOn: this.state.captionsOn
    })
  }

  back = () => {
    this.setState({
      vid: true,
      surv: false,
      fin: false,
      activity: false,
      captionsOn: this.state.captionsOn
    })
  }

  render() {
    return (
      <div className="page">
        <Header
          logo={config.logo}
          title={config.title}
          isAuthenticated={this.state.isAuthenticated}
          userHasAuthenticated={this.userHasAuthenticated}
        />
        <div className="main">
          {!this.state.isAuthenticated && (
            <Login
              userHasAuthenticated={this.userHasAuthenticated}
            />
          )}
          {this.state.vid && (
            <div>
            <Player
              index={this.state.ix}
              onEnd={() => this.onVidEnd()}
              textChanged={() => this.onTextChange()}
              onClickPlaylistItem={i => this.ix(i)}
              playlist={config.playlist}
              captionOn={this.state.captionsOn}
            />
            </div>
          )}
          {this.state.activity && (
            <div>
            <CSSTransitionGroup
              transitionName="example"
              transitionAppear={true}
              transitionAppearTimeout={2500}
              transitionEnter={false}
              transitionLeave={false}>
              <Activity
                index={this.state.ix}
                onEnd={() => this.onVidEnd()}
                onClickPlaylistItem={i => this.ix(i)}
                playlist={config.playlist}
                module={config.playlist[this.state.ix].activity}
              />
            </CSSTransitionGroup>
            </div>
          )}
          {this.state.surv && (
            <Survey
              building={config.building}
              module={config.playlist[this.state.ix].survey}
              onComplete={() => this.setCompl()}
              onBack={() => this.back()}
              user={this.state.user}
            />
          )}
          {this.state.fin &&
          <Ending
            onBack={() => this.back()}
            captionOn={this.state.captionsOn}
            textChanged={() => this.onTextChange()}
            user={this.state.user}/>
          }
        </div>
        {this.state.vid && (
          <div>
            <span className="video-title-text">
              {config.playlist[this.state.ix].title}
            </span>
            <br/> <br/>
            {config.playlist[this.state.ix].subtitle && (
              <span className="video-subtitle-text">
                {config.playlist[this.state.ix].subtitle}
              </span>
            )}
            <p className="video-description">
              {config.playlist[this.state.ix].text}
            </p>
          </div>
        )}
        <Footer copyright={config.copyright}/>
      </div>
    )
  }

  setCompl = () => {
    let recs = !this.isCompleted(this.state.recs)
    if (recs === null) {
      recs = true
    }
    if (recs) {
      console.log("done");
      this.setState({
        fin: true,
        surv: false,
        vid: false,
        activity: false
      })
    } else if (this.state.ix < (config.playlist.length - 1)) {
      this.setState({
        ix: this.state.ix + 1,
        surv: false,
        vid: true,
        activity: false
      })
    } else if (this.state.ix === (config.playlist.length - 1)) {
      const index = this.isCompleted(this.state.recs)
      const firstIncomplete = config.playlist.findIndex(x => x.survey === index)
      if (firstIncomplete === this.state.ix) {
        this.setState({
          surv: false,
          vid: true,
          activity: false
        })
      } else {
        this.setState({
          ix: firstIncomplete > 0 ? firstIncomplete : 0,
          surv: false,
          vid: true,
          activity: false
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/App.js